<template>
  <vs-table
    no-data-text="No tienes destinatarios"
    :data="subjects"
    class="table"
  >
    <template slot="thead">
      <vs-th>Destino</vs-th>
      <vs-th>Lista Destino</vs-th>
      <vs-th>Extra</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="subject" v-for="(subject, indextr) in data" :key="indextr">
        <vs-td :data="subject.subjectType.label">
          {{subject.subjectType.label}}
        </vs-td>
        <vs-td :data="subject.subject.label">
          {{subject.subject.label}}
        </vs-td>
        <vs-td
          v-if="subject.subjectTypeDigitalDoc.label"
          :data="subject.subjectTypeDigitalDoc.label"
        >
          {{subject.subjectTypeDigitalDoc.label}}
          <small class="d-block">institución</small>
        </vs-td>
        <vs-td
          v-if="subject.providence"
          :data="subject.providence"
        >
          {{providencesMap[subject.providence]}}
          <span v-if="subject.providenceExpiration">
             - {{subject.providenceExpiration}}
          </span>
          <small class="d-block">providencia</small>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';

export default {
  data() {
    return {
      providencesMap: ProvidencesMap
    };
  },
  props: {
    subjects: {
      type: Array,
      required: false,
      default: () => []
    },
  }
};
</script>
